import { Lead } from '@jms/model';

// Board card text for a Lead. Shared by the manifest's `summarize` (list/table density) and the card
// renderer component, so both print the same title for a lead whose name has not been derived yet.

export function leadCardTitle(lead: Lead | null | undefined): string {

  return lead?.name?.trim() || lead?.account?.name?.trim() || 'Not set';
}

export function leadCardSummary(lead: Lead): { title: string; line1?: string; line2?: string; line3?: string } {

  return {
    title: leadCardTitle(lead),
    line1: lead.description || undefined,
    line2: lead.contact?.name || undefined,
    line3: lead.company?.name || undefined,
  };
}
